import Select from 'react-select';
import { ClearBtn, SearchBtn } from "../../Buttons/Buttons";
import { Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useRef, useState } from 'react';
import { loadIndustryDropdown, loadGetUploadUser, loadReportIndustryCountData, getReportDataIndustryCount } from '../../redux/action';
import moment from 'moment';
import {
    CircularProgressbar,
    CircularProgressbarWithChildren,
    buildStyles
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import _ from "lodash";
import { Circles } from 'react-loader-spinner';
import { Skeleton } from '@mui/material';
import { Typeahead } from 'react-bootstrap-typeahead';

const IndustryDataCount = ({ isActive }) => {
    const dispatch = useDispatch();
    const scrollContainerRef = useRef(null);
    const typeaheadRef = useRef(null);

    const { reportDataIndustryCount } = useSelector((state) => state.data);
    const { totalDataCount } = useSelector((state) => state.data);
    const { getUploadUser } = useSelector((state) => state.data);
    const { industryDropdown } = useSelector((state) => state.data);

    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [limit] = useState(20);
    const [selectedUser, setSelectedUser] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [loadingMore, setLoadingMore] = useState(false);
    const [uploadCount, setUploadCount] = useState(null);
    const [search, setSearch] = useState("");
    const [selected, setSelected] = useState([]);
    const [industry, setIndustry] = useState([]);
    const [industryCountData, setIndustryCountData] = useState([]);

    const fetchReportIndustryCountData = () => {
        const formattedFromDate = fromDate ? moment(fromDate).format('YYYY-MM-DD') : '';
        const formattedToDate = toDate ? moment(toDate).format('YYYY-MM-DD') : '';
        dispatch(loadReportIndustryCountData(selectedUser?.value || '', selected || '', formattedFromDate, formattedToDate, page, limit, setLoading, setLoadingMore, reportDataIndustryCount, setUploadCount));
    }

    useEffect(() => {
        if (isActive) {
            setLoading(true);
            fetchReportIndustryCountData()
        }
    }, [isActive]);

    useEffect(() => {
        setIndustry(industryDropdown);
    }, [industryDropdown]);

    useEffect(() => {
        setIndustryCountData(reportDataIndustryCount);
    }, [reportDataIndustryCount]);

    useEffect(() => {
        if (isActive) {
            dispatch(loadGetUploadUser());
        }
    }, [isActive]);

    useEffect(() => {
        if (search) {
            setLoading(true);
            dispatch(loadIndustryDropdown(search, setLoading));
        }
    }, [search])

    useEffect(() => {
        if (selected || selectedUser || fromDate || toDate) {
            setPage(1);
        }
    }, [selected, selectedUser, fromDate, toDate])

    
    const handleSearch = () => {
        setIndustryCountData([]); // clear local list
        setPage(1);               // reset pagination

        const formattedFromDate = fromDate ? moment(fromDate).format('YYYY-MM-DD') : '';
        const formattedToDate = toDate ? moment(toDate).format('YYYY-MM-DD') : '';

        dispatch(loadReportIndustryCountData(
            selectedUser?.value || '',
            selected || '',
            formattedFromDate,
            formattedToDate,
            1,
            limit,
            setLoading,
            setLoadingMore,
            [],               // reset report data
            setUploadCount
        ));
    };

    useEffect(() => {
        const handleScroll = () => {
            const container = scrollContainerRef.current;
            if (!container) return;

            // Calculate how far from the bottom the user is
            const distanceFromBottom = container.scrollHeight - container.scrollTop - container.clientHeight;

            // If the user is near the bottom (distance < a threshold, e.g., 10px)
            if (distanceFromBottom <= 1 && !loadingMore && reportDataIndustryCount?.length < totalDataCount) {
                fetchMoreIndustry(); // Trigger fetching more industries
            }
        };


        // Attach scroll event listener
        const container = scrollContainerRef.current;
        if (container) {
            container.addEventListener('scroll', handleScroll);
        }

        // Clean up the event listener on unmount
        return () => {
            if (container) {
                container.removeEventListener('scroll', handleScroll);
            }
        };
    }, [loadingMore, reportDataIndustryCount?.length, totalDataCount]);

    const fetchMoreIndustry = () => {
        if (loadingMore) {
            return;
        }

        setLoadingMore(true);
        const nextPage = page + 1;
        setPage(nextPage);// Increment the page number for next fetch

        // fetchReportIndustryCountData();
        const formattedFromDate = fromDate ? moment(fromDate).format('YYYY-MM-DD') : '';
        const formattedToDate = toDate ? moment(toDate).format('YYYY-MM-DD') : '';
        dispatch(loadReportIndustryCountData(selectedUser?.value || '', selected || '', formattedFromDate, formattedToDate, nextPage, limit, setLoading, setLoadingMore, reportDataIndustryCount, setUploadCount));
    };

    function Separator(props) {
        return (
            <div
                style={{
                    position: "absolute",
                    height: "100%",
                    transform: `rotate(${props.turns}turn)`
                }}
            >
                <div style={props.style} />
            </div>
        );
    }

    function RadialSeparators(props) {
        const turns = 1 / props.count;
        return _.range(props.count).map(index => (
            <Separator turns={index * turns} style={props.style} />
        ));
    }

    const handleClear = () => {
        setSelected([]);
        setSearch('');
        // setIndustry([]);
        typeaheadRef.current?.clear(); // ← This resets the Typeahead UI
        setSelectedUser('');
        setFromDate('');
        setToDate('');
        dispatch(loadReportIndustryCountData('', '', '', '', 1, limit, setLoading, setLoadingMore, '', setUploadCount));
    }

    return (
        <div>
            <Row className="m-0 align-items-center">
                <Col md={2} className="pe-0">
                    <Typeahead
                        ref={typeaheadRef}
                        className="w-100"
                        id="contact-level"
                        // options={previousJoblevelDropdownData ? previousJoblevelDropdownData?.map(opt => opt.label).filter(opt => !selected.includes(opt)) : []}  // Here, we map the array to use only labels
                        options={
                            loading
                                ? ['Loading data...']  // Show "Loading data..." message while loading
                                : industry?.map(opt => opt.label).filter(opt => !selected.includes(opt))  // Show actual options when data is available
                        }
                        placeholder="Enter Industry"
                        onInputChange={(val) => {
                            setSearch(val); // Update search state
                            // if (val.trim() === '') {
                            //     setSearch("");  // Set it to empty string when cleared
                            // }
                        }}
                        onChange={(val) => {
                            if (val.length > 0 && !selected.includes(val[0])) {
                                setSelected([...selected, val[0]]);
                                setIndustry([]);
                                setSearch('');
                            }
                        }}
                    />
                </Col>
                <Col md={2} className="pe-0">
                    <Select
                        className="react-select-container"
                        classNamePrefix="react-select"
                        options={getUploadUser}
                        placeholder="Select User"
                        onChange={(option) => setSelectedUser(option)}
                        value={selectedUser}
                    />
                </Col>
                <Col md={2} className="pe-0">
                    <input
                        type="date"
                        className="form-control"
                        value={fromDate}
                        onChange={(e) => setFromDate(e.target.value)}
                        placeholder="From Date"
                    />
                </Col>

                <Col md={2} className="pe-0">
                    <input
                        type="date"
                        className="form-control"
                        value={toDate}
                        onChange={(e) => setToDate(e.target.value)}
                        placeholder="To Date"
                    />
                </Col>
                <Col md="auto" className="pe-0">
                    <SearchBtn btnName='Search' onClickEffect={handleSearch} />
                </Col>
                <Col md="auto" className="pe-0">
                    <ClearBtn btnName='Clear' onClickEffect={handleClear} />
                </Col>
                <Col className="pe-0 ms-auto">
                    <div className="upload-report-count" style={{ float: 'right' }}>
                        <h6>Total Upload Count <p> {uploadCount || 0}</p></h6>
                    </div>
                </Col>
            </Row>
            <div className="upload-report-card-container country-count-container" ref={scrollContainerRef}>
                <Row className="mt-4 m-0">
                    {loading ? (
                        // Skeleton Loader Cards (placeholder)
                        Array.from({ length: 4 }).map((_, index) => (
                            <Col md={3} key={index} className='mb-4'>
                                <div className="summary-card data-count-card">
                                    <Skeleton height={20} width={100} style={{ marginBottom: 8 }} />
                                    <Skeleton height={30} width={80} style={{ marginBottom: 16 }} />
                                    <div style={{ width: '100px', height: '100px', margin: '0 auto' }}>
                                        <Skeleton circle={true} height={100} width={100} />
                                    </div>
                                </div>
                            </Col>
                        ))
                    ) :
                        industryCountData && industryCountData.length ? (
                            industryCountData.map((data) => (
                                <Col md={3} key={data.country} className='mb-4'>
                                    <div className="summary-card data-count-card row m-0">
                                        <div className='summary-card-country-count col-md-8'>
                                            <h5 className="summary-card-title">{data.industry}</h5>
                                            <h4 className='m-0'>{data.total_count}</h4>
                                        </div>
                                        <div className='col-md-4 p-0'>
                                            <CircularProgressbarWithChildren
                                                className='circular-progress-bar-of-report-count'
                                                value={80}
                                                text={`${data.percentage.toFixed(2)}%`}
                                                strokeWidth={10}
                                                styles={buildStyles({
                                                    strokeLinecap: "butt"
                                                })}
                                            >
                                                <RadialSeparators
                                                    count={12}
                                                    style={{
                                                        background: "#fff",
                                                        width: "2px",
                                                        height: `${10}%`
                                                    }}
                                                />
                                            </CircularProgressbarWithChildren>
                                        </div>
                                    </div>
                                </Col>
                            ))
                        ) : (
                            <Col>
                                <p>No country data available.</p>
                            </Col>
                        )}
                    {loadingMore && <div className='loader-css'>
                        <div className="d-flex justify-content-center align-items-center py-4">
                            <Circles
                                height="30"
                                width="30"
                                color="#007bff"
                                ariaLabel="circles-loading"
                                visible={true}
                            />
                        </div>
                    </div>}
                </Row>
            </div>
        </div>
    );
};

export default IndustryDataCount;
